// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemePalette } from "@angular/material/core";
import { ProgressSpinnerMode } from "@angular/material/progress-spinner";
// Extern
import { Subscription } from 'rxjs';
// Models
import { SpinnerStatus } from 'src/app/models/spinner-status.model';
// Services
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {

  color: ThemePalette = 'accent';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 20;
  isSpinning: boolean = false;
  spinnerMessage: string = 'In progress...';
  spinnerPercentage: number = 0.80;
  spinnerStatusSubscription: Subscription;

  constructor(private notificationsService: NotificationsService) {
    this.subscribeToSpinnerStatus();
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if(this.spinnerStatusSubscription!=undefined) { this.spinnerStatusSubscription.unsubscribe(); }
  }

  subscribeToSpinnerStatus() {
    this.spinnerStatusSubscription = this.notificationsService.spinnerSubject.subscribe(
      (spinnerStatus: SpinnerStatus) => {
        if (spinnerStatus) {
          this.isSpinning = spinnerStatus.isSpinning;
          this.spinnerMessage = spinnerStatus.message;
          this.spinnerPercentage = spinnerStatus.percentage;
        }
      }
    );
    this.notificationsService.emitSpinner();
  }

}
